module.exports = __webpack_public_path__ + "img/account.ac323e76.png";